import "core-js/modules/es.date.to-string.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect, useState } from 'react';
import memoize from 'fast-memoize';

function createHiddenInputForRingpool(key, value) {
  var hasExistingInput = document.getElementsByName(key).length;

  if (!hasExistingInput && key && value) {
    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute('value', value); //append to form element that you want

    document.body.appendChild(input);
  }
}

function loadRingpoolScript(callback) {
  var existingScript = document.getElementById('ringpoolScript');

  if (!existingScript) {
    var script = document.createElement('script');
    script.src = "".concat(process.env.GATSBY_CF_RINGCENTER_BASE_URL, "/Resources/JS/autoringpool-latest-v4.js");
    script.id = 'ringpoolScript';
    document.body.appendChild(script);

    script.onload = function () {
      if (callback) {
        callback();
      }
    };
  }

  if (existingScript && callback) {
    callback();
  }
}

var getQtOfferData = memoize( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(affId, offerId) {
    var url, params, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = new URL("".concat(process.env.GATSBY_RFQ_API_BASE_URL, "/v2/qt/offer"));
            params = {
              affId: affId,
              offerId: offerId
            };
            url.search = new URLSearchParams(params).toString();
            _context.next = 6;
            return fetch(url);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            throw new Error(_context.t0);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
export function useQt(_ref2) {
  var affId = _ref2.affId,
      offerId = _ref2.offerId;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      offer = _useState2[0],
      setOffer = _useState2[1];

  useEffect(function () {
    var getOfferData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getQtOfferData(affId, offerId);

              case 3:
                data = _context2.sent;
                setOffer(data);

                if (data.ringpoolId && data.ringpoolDefaultPhone) {
                  createHiddenInputForRingpool('cf_attr1', affId);
                  createHiddenInputForRingpool('cf_attr2', document.location.href);
                  setTimeout(function () {
                    loadRingpoolScript();
                  }, 500);
                }

                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);
                setOffer({});

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function getOfferData() {
        return _ref3.apply(this, arguments);
      };
    }();

    if (affId && offerId) {
      getOfferData();
    }
  }, [affId, offerId]);
  return offer;
}